module.exports = __webpack_public_path__ + "img/ez-slot-guitar-card.0485d00b.png";